// eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides
import { styled, type StyledProps } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line import/order
// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFooterWrapper } from './ai-answer-footer-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFeedbackWrapper } from './ai-answer-feedback-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsEditedByFooterWrapper } from './reading-aids-edited-by-footer-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsEditedByFeedbackWrapper } from './reading-aids-edited-by-feedback-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerReportDescriptionWrapper } from './ai-answer-report-description-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { FeedbackButtonIconWrapper } from './feedback-button-icon-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { Rotate180IconWrapper } from './rotate180-icon-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFooterTitle } from './ai-answer-footer-title';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerTooltipWrapper } from './ai-answer-tooltip-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerInformationIconColor } from './ai-answer-information-icon-color';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerInformationIconWrapper } from './ai-answer-information-icon-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerInformationTooltipLink } from './ai-answer-information-tooltip-link';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFooterOptionWrapper } from './ai-answer-footer-option-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFollowUpPill } from './ai-answer-follow-up-pill';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFollowUpPillText } from './ai-answer-follow-up-pill-text';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsAnswerFooterWrapper } from './reading-aids-answer-footer-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsWrapper } from './reading-aids-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFooterInformationContentVary } from './ai-answer-footer-information-content-vary';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFooterInformationContentVaryLinkText } from './ai-answer-footer-information-content-vary-link-text';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFooterPoweredBy } from './ai-answer-footer-powered-by';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFooterContentWarningLink } from './ai-answer-footer-content-warning-link';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFooterPoweredByLink } from './ai-answer-footer-powered-by-link';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AIAnswerFooterPoweredByAIWrapper } from './ai-answer-footer-powered-by-ai-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsFooterTitle } from './reading-aids-footer-title';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsFeedbackLabel } from './reading-aids-feedback-label';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsTooltipWrapper } from './reading-aids-tooltip-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsInformationIconColor } from './reading-aids-information-icon-color';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsBannerWrapper } from './reading-aids-banner-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsBannerHeader } from './reading-aids-banner-header';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsBannerIconWrapper } from './reading-aids-banner-icon-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsBannerDescription } from './reading-aids-banner-description';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsEditWrapper } from './reading-aids-edit-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsEditedByWrapper } from './reading-aids-edited-by-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ReadingAidsEditHistoryWrapper } from './reading-aids-edit-history-wrapper';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const AIAnswerContentBrandBase = styled.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	paddingTop: token('space.050'),
	paddingRight: token('space.300'),
	paddingBottom: token('space.050'),
	paddingLeft: token('space.300'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIAnswerContentBrandWrapper: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled(AIAnswerContentBrandBase)({
	justifyContent: 'space-between',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIAnswerContentBrandWrapperCentered: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled(AIAnswerContentBrandBase)({
	justifyContent: 'center',
});
